import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { UserData } from '../../types/user';
import { CostBreakdown } from '../../types/renovation';
import { Language } from '../../types/language';
import { AppError } from '../errorHandling';
import { formatUserDataForFirestore } from './formatters';

export async function saveUserData(
  userData: UserData,
  breakdown: CostBreakdown[],
  language: Language
): Promise<string> {
  try {
    if (!userData.email) {
      throw new Error('Email is required');
    }

    if (!breakdown || breakdown.length === 0) {
      throw new Error('No services selected');
    }

    const formattedData = formatUserDataForFirestore(userData, breakdown, language);
    const userCollection = collection(db, 'users');
    
    const docRef = await addDoc(userCollection, {
      ...formattedData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    console.log('Document written with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('Firebase save error:', error);
    
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    throw new AppError(
      errorMessage,
      'FIREBASE_ERROR',
      {
        en: 'Failed to save your data. Please try again.',
        fr: 'Échec de la sauvegarde de vos données. Veuillez réessayer.'
      }
    );
  }
}